import React from "react"
import DateHelper from "../../DateHelper/DateHelper"

class FolioBuilderRoomTaxSummaryRow extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var self = this;
    var date = this.props.date
    var description = "Room Tax"
    var amount = this.props.tax




    var row = [
      <td className="date" key={this.props.date}>{DateHelper.parseDate(date).toString(DateHelper.rubyToDateJS(self.props.date_format))}</td>,
      <td className="description" key={"420"}>{description}</td>,
      <td className="amount" key={this.props.tax}>{amount}</td>
    ]

    return(
      <tr>
        {row}
      </tr>
    )
  }
}

export default FolioBuilderRoomTaxSummaryRow